<template>
	<div>
		<div class="main-filter">
			<el-form inline :model="formInline" class="demo-form-inline">
				<el-form-item label="设备名称：">
					<el-autocomplete
						v-model.trim="formInline.name"
						:fetch-suggestions="querySearchAsync"
						clearable
						placeholder="请输入内容"
						@select="handleSelect"
					></el-autocomplete>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSearch" icon="el-icon-search">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="main-content">
			<div class="main-content-title">
				<p>共有 {{ total }} 条结果</p>
				<el-button type="primary" @click="modifyParkInfo($event, false)" icon="el-icon-plus">新增</el-button>
			</div>
			<Table
				:loading="loading"
				:table-data="tableData"
				:total="total"
				:table-head="tableHead"
				:current-page.sync="queryData.current"
				:page-size.sync="queryData.size"
				:operation-column-width="140"
				:is-show-selection="false"
				:showOperation="true"
				@change-page="getList"
				:tableHeight="tableHeight"
			>
				<!-- 插槽操作栏固定属性operation -->
				<template #enabled="{ scope }">
					<el-switch inactive-text="否" active-text="是" v-model="scope.row.enabled" @change="changeOpen(scope.row)"> </el-switch>
				</template>
				<template #showParam="{ scope }">
					<el-button @click="showParams(scope.row)" size="mini" type="text"> 查看 </el-button>
				</template>
				<template #operation="{ scope }">
					<el-button @click="modifyParkInfo($event, true, scope.row)" size="mini" type="primary"> 查看 </el-button>
					<el-button
						@click="modifyParkInfo($event, false, scope.row)"
						size="mini"
						:type="scope.row.enabled ? 'info' : 'warning'"
						:disabled="scope.row.enabled"
					>
						修改
					</el-button>
				</template>
			</Table>
		</div>
		<createView ref="createView" :isShowDetail="isShowDetail" @getList="getList"></createView>
		<el-dialog title="查看pdf文件" :visible.sync="pdfVisible" width="800px" center top="5vh">
			<iframe class="pdfClass" ref="mainiframe" :src="viewUrlPdf" style="width: 100%" :style="{ height: screenHeight + 'px' }"></iframe>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'deviceManager',
	components: {
		Table: () => import('@/components/Table/table'),
		createView: () => import('./newDialog.vue'),
	},
	data() {
		return {
			pdfVisible: false,
			formInline: {
				name: '',
			},
			tableHead: [
				{
					label: '设备名称',
					prop: 'name',
					formatter: (row) => {
						return row.name || '-';
					},
				},
				{
					label: '规格型号',
					prop: 'modelName',
					formatter: (row) => {
						return row.modelName || '-';
					},
				},
				{
					label: '设备厂家',
					prop: 'manufacturerDictionaryItem',
					formatter: (row) => {
						return row.manufacturerDictionaryItem?.title || '-';
					},
				},
				{
					label: '参数表',
					prop: 'showParam',
				},
				// {
				// 	label: '设备图片',
				// 	prop: 'photo',
				// 	width: 100,
				// 	showOverflowTooltip: false,
				// },
				{
					label: '是否启用',
					prop: 'enabled',
					width: 110,
				},
			],
			loading: false,
			queryData: {
				current: 1,
				size: 10,
			},
			total: 0,
			tableData: [],
			options: [],
			isShowDetail: false,
			viewUrlPdf: '',
			link: '',
		};
	},

	computed: {
		tableHeight() {
			return window.innerHeight - 300;
		},
		screenHeight() {
			return document.body.clientHeight - 220;
		},
	},
	mounted() {
		this.getList();
	},
	methods: {
		// 查询条件
		onSearch() {
			this.queryData.current = 1;
			this.getList(null);
		},
		handleSelect(subInput) {
			this.formInline.name = subInput.name;
		},
		changeOpen(row) {
			this.$http
				.put(row._links.update.href, row)
				.then((res) => {
					if (res.data && res.data.success) {
						this.$message.success('操作成功');
						this.getList();
					}
				})
				.catch((e) => {});
		},
		// 搜索建议
		querySearchAsync(queryString, cb) {
			queryString ? this.getList('filter') : '';
			clearTimeout(this.timeout);
			this.timeout = setTimeout(() => {
				cb(this.options);
			}, 1000 * Math.random());
		},
		//获取列表
		getList(type = '') {
			type == 'filter' ? '' : (this.loading = true);
			let data = {
				...this.formInline,
				...this.queryData,
			};
			this.$http
				.get(this.api['SmartDeviceModel#index'].href, { params: data })
				.then((res) => {
					if (res.data && res.data.success) {
						if (type == 'filter') {
							this.options = res.data.collection.map((item) => {
								return {
									...item,
									value: item.name,
								};
							});
						} else {
							this.link = res.data._links.create.href || '';
							this.tableData = res.data.collection || [];
							this.total = res.data.pagination.totalItems || 0;
							this.loading = false;
						}
					}
				})
				.catch((e) => {
					this.loading = false;
				});
		},
		modifyParkInfo(event, isShowDetail, row) {
			let data = {
				row: row || null,
				link: row ? row._links.update.href : this.link,
			};
			this.$refs.createView.init(data);
			this.isShowDetail = isShowDetail;
		},
		showParams(row) {
			this.pdfVisible = true;
			this.viewUrlPdf = row.attachmentDtoMap['DOCUMENT'][0].link;
		},
	},
};
</script>

<style lang="scss" scoped>
.demo-form-inline {
	/deep/ .el-select {
		width: 120px !important;
		.el-input {
			width: 120px !important;
			.el-input__inner {
				width: 120px !important;
			}
		}
	}
	/deep/ .el-input {
		width: 160px;
	}
}
.main-content {
	&-title {
		line-height: 48px;
		display: flex;
		justify-content: space-between;
		.el-button {
			line-height:32px;
			padding: 0 16px;
			height: 32px;
			margin-top: 8px;
		}
	}
	.imgsClass {
		img {
			width: 60px;
			height: 60px;
		}
	}
}
</style>